// extracted by mini-css-extract-plugin
module.exports = {"container":"ColorBubble_container__QT8-_","selected":"ColorBubble_selected__3nUPS","image":"ColorBubble_image__7rp-J"};